/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetTicketsBatchPdfRequest } from '../../models/get-tickets-batch-pdf-request';

export interface PostGeneratePdfBatch$Params {
  body?: GetTicketsBatchPdfRequest;
}

export function postGeneratePdfBatch(
  http: HttpClient,
  rootUrl: string,
  params?: PostGeneratePdfBatch$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<any>> {
  const rb = new RequestBuilder(rootUrl, postGeneratePdfBatch.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(rb.build({ responseType: 'blob', accept: 'application/pdf', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<any>;
    }),
  );
}

postGeneratePdfBatch.PATH = '/Tickets/generate-pdf-batch';
